<h2>Home</h2>
<p>Welcome to the DEM client.</p>
<p>Select something you want to work with.</p>
<div class="hidden">
  <button (click)="test()">test api</button>
  <button (click)="test2()">create particle</button>
</div>
